import type { ReactNode } from 'react';

export function SectionHeader({
  title,
  subtitle,
  actions,
}: {
  title: string;
  subtitle?: string;
  actions?: ReactNode;
}) {
  return (
    <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3 sm:gap-4">
      <div>
        <h1 className="font-display text-xl sm:text-2xl font-bold tracking-widest text-white uppercase">
          {title}
        </h1>
        {subtitle && (
          <p className="text-xs font-jetbrains-mono text-neon-cyan/90 mt-1">// {subtitle}</p>
        )}
      </div>
      {actions && <div className="flex flex-col sm:items-end gap-2">{actions}</div>}
    </div>
  );
}
